import React from 'react';
import {
  Navbar,
  Hero,
  Services,
  About,
  Products,
  Partners,
  Clients,
  Testimonials,
  Gallery,
  Contact,
  Footer
} from './components';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Products />
      <Partners />
      <Clients />
      <Testimonials />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
